var r=function(r,a){for(var n=-1,t=null==r?0:r.length,e=0,l=[];++n<t;){var u=r[n];a(u,n,r)&&(l[e++]=u)}return l};export{r as default};
//# sourceMappingURL=_arrayFilter.js.map
